/**
 * Generates the title for the state directory page.
 *
 * @param {string} stateName - The full name of the state (e.g., "California").
 * @returns {string} The generated title for the state directory page.
 */
export const generateStateDirectoryTitle = (stateName) => {
  const title = 'The Home Depot Store Directory';
  if (!stateName) {
    return title;
  }

  return title + ` - ${stateName}`;
};

/**
 * Generates the meta description for the state directory page.
 *
 * @param {string} stateName - The full name of the state (e.g., "California").
 * @returns {string} The generated meta description for the state directory page.
 */
export const generateStateDirectoryDesc = (stateName) => {
  if (!stateName) {
    return 'The Home Depot';
  }

  return `The Home Depot in ${stateName} is here to help with your home improvement needs.`
    + ` Stop by at one of our ${stateName} locations today.`;
};